
import { IRadioOption } from 'app/interfaces/IRadioOption';

export const copyMethodOptionValues = {
    PolyBase: 'polyBase',
    CopyCommand: 'copyCommand',
    BulkInsert: 'Insert',
    Upsert: 'Upsert',
    SCD2: 'SCD2'
};
export type CopyMethodOptionValue = 'polyBase' | 'copyCommand' | 'Insert' | 'Upsert' | 'SCD2';

export const copyMethodSettingOptions: Array<IRadioOption<CopyMethodOptionValue>> = [
    {
        label: stringResources.CopyCommand,
        value: copyMethodOptionValues.CopyCommand as CopyMethodOptionValue,
        descriptionNotEscape: true,
        description: stringResources.CopyCommand_Description +
            '<a target="_blank" href="https://aka.ms/copy-statement">' + stringResources.LearnMore + '</a>'
    },
    {
        label: stringResources.PolybaseSetting_Polybase_Label,
        value: copyMethodOptionValues.PolyBase as CopyMethodOptionValue,
        descriptionNotEscape: true,
        description: stringResources.PolybaseSetting_PolybaseToolTip +
            '<a target="_blank" href="https://aka.ms/polybase-to-load-data">' + stringResources.LearnMore + '</a>'
    },
    {
        label: stringResources.CopyMethod_BulkInsert_Label,
        value: copyMethodOptionValues.BulkInsert as CopyMethodOptionValue
    },
    {
        label: stringResources.WriteBehavior_Option_Upsert,
        value: copyMethodOptionValues.Upsert as CopyMethodOptionValue
    }
];

export const useBulkInsertTableLockOptions: Array<IRadioOption<boolean>> = [
    {
        label: stringResources.Yes,
        value: true
    }, {
        label: stringResources.No,
        value: false
    }
];

export const SINGLE_COPY_METHOD_SETTINGS_LABELS: Partial<Record<CopyMethodOptionValue, string>> = {
    copyCommand: stringResources.CopyCommand_Settings
};
